import { getHostName } from '../config/env';

const redirectToLogin = (): void => {
  const url = `https://login.${getHostName()}.com`;
  window.location.assign(`${url}?origin=${window.location.href}`);
};

const redirectToDashboard = (): void => {
  window.location.assign(`https://${getHostName()}.com`);
};

export { redirectToLogin, redirectToDashboard };
